<div class="wrap">
  <div class="wrap__card" #cardRef></div>
</div>
